// Safe localStorage wrapper. Returns null on any read failure and swallows
// write/remove failures silently. This shields the app from browsers where
// localStorage is disabled (private mode in some Safari builds, blocked by
// site settings, quota exceeded, sandboxed iframes, etc.).

export function getItem(key) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeItem(key) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

const safeStorage = { getItem, setItem, removeItem };
export default safeStorage;
